import {
  GraphQLObjectType,
  GraphQLNonNull,
  GraphQLInt,
  GraphQLID
} from 'graphql'

export const jobStatusType = new GraphQLObjectType({
  name: 'JobStatus',
  fields: {
    id: {
      description: 'The unique ID of the job',
      type: new GraphQLNonNull(GraphQLID)
    },
    total: {
      description: 'A number representing the completion of the job',
      type: new GraphQLNonNull(GraphQLInt)
    },
    progress: {
      description:
        'A number representing the fraction of the total completed so far',
      type: new GraphQLNonNull(GraphQLInt)
    }
  }
})
